<article *ngIf="data" class="w-full" style="height: 100dvh;">
  <section class="w-full h-full bg-cover bg-center ci-main-padding relative flex flex-column justify-content-end"
    style="background: url({{data.assets.backgroundUrl}});">
    <section class="z-3 relative">
      <section class="fadeindown animation-duration-500">
        <h3 class="text-4xl md:text-7xl font-semibold ci-txt--{{data?.color}}">
          {{ data.name }}
        </h3>

        <p class="text-xl sm:text-2xl md:text-3xl ci-txt--white my-3">
          {{ data.description }}
        </p>
      </section>

      <section *ngIf="data?.data?.gallery?.length > 0" class="w-full my-3 md:mt-6 fadeindown animation-duration-500">
        <swiper-container scrollbar-hide="true" slides-per-view="auto" free-mode="true" space-between="30"
          autoplay-delay="2500">
          <swiper-slide *ngFor="let item of data?.data?.gallery"
            class="w-fit fadein animation-duration-1000 cursor-pointer">
            <section class="ci-project-card w-18rem h-12rem shadow-3 border-round-xl overflow-hidden relative bg-white-alpha-10"
                     (click)="scrollToSection(data.slug+'-gallery')">
              <section class="ci-project-card__image w-full h-full bg-cover bg-center bg-no-repeat"
                       style="background-image: url({{item.photos[0]}});">
                <section class="ci-project-card__overlay-bg w-full h-full absolute top-0 left-0"></section>
              </section>
            </section>
          </swiper-slide>
        </swiper-container>
      </section>
    </section>

    <section class="w-full h-full bg-black-alpha-70 absolute top-0 right-0 left-0 bottom-0 z-2"></section>

    <section class="flex justify-content-center z-3 mb-3 fadeindown animation-duration-500">
      <i class="bi bi-chevron-double-down ci-txt--white text-3xl md:text-4xl ci-project-banner__arrow-down cursor-pointer"
        (click)="scrollToFeatureSection()">
      </i>
    </section>
  </section>
</article>